var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"show":_vm.dismissCountDown,"variant":_vm.message.type},on:{"dismissed":function($event){_vm.dismissCountDown=0}}},[_vm._v(" "+_vm._s(_vm.message.text)+" "),_c('b-button',{staticClass:"right-button",attrs:{"variant":"close"},on:{"click":function($event){return _vm.closeIt()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }